import React from 'react';
import styled from 'styled-components';

import { useNavMenu } from '../../../Providers/NavMenuContext';
import { useModal } from '../../../Providers/ModalContext';

//Logos
import KuterXX from '../../../../Images/logos/grid/kuter_xx.png';
import KuterFilms from '../../../../Images/logos/grid/kuter_films.png';
import xFilms from '../../../../Images/logos/grid/x_films.png';
import KuterStudio from '../../../../Images/logos/grid/kuter_studio.png';
import xStudio from '../../../../Images/logos/grid/x_studio.png';
import KuterPost from '../../../../Images/logos/grid/kuter_post.png';
import xPost from '../../../../Images/logos/grid/x_post.png';
import KuterAi from '../../../../Images/logos/grid/kuter_ai.png';
import xAi from '../../../../Images/logos/grid/x_ai.png';
import KuterHuman from '../../../../Images/logos/grid/kuter_human.png';
import xHuman from '../../../../Images/logos/grid/x_human.png';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const MainLogo = styled.img`
  width: 278px;
  height: auto;
  display: block;
  margin: 0 auto;

  @media (max-width: ${breakpoints.tablet}) {
    width: 190px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 135px;
  }
`;

const Container = styled.div`
  padding: 110px 0px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  row-gap: 3rem;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 50px 0px;
    row-gap: 1.5rem;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 20px 0px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    row-gap: 1rem;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  column-gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: ${breakpoints.mobile}) {
    row-gap: 1rem;
  }
`;

const TwoColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  &.clickable {
    cursor: pointer;
  }
`;

const XImg = styled.img`
  width: 245px;
  height: auto;
  display: block;

  @media (max-width: ${breakpoints.tablet}) {
    width: 190px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 116px;
  }
`;

const GridLogo = styled.img`
  width: 269px;
  height: auto;
  display: block;

  @media (max-width: ${breakpoints.tablet}) {
    width: 175px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 135px;
  }
`;

const LogoContainer = () => {
  const { openMenu } = useNavMenu();
  const { openModal } = useModal();

  const goToFilms = () => openMenu('films', ['main']);
  const goToStudio = () => openMenu('studio', ['main']);
  const goToAiServices = () => openModal('ai-services');
  const goToPostProduction = () =>
    openMenu('studio', ['main', 'portfolio', 'postProduction']);

  return (
    <>
      <Container>
        <Row>
          <MainLogo src={KuterXX} alt="Kuter XX" />
        </Row>
        <Row>
          <TwoColumn className="clickable" onClick={goToFilms}>
            <XImg src={xFilms} alt="X Films" />
            <GridLogo src={KuterFilms} alt="Kuter Films" />
          </TwoColumn>
          <TwoColumn className="clickable" onClick={goToStudio}>
            <XImg src={xStudio} alt="X Stydio" />
            <GridLogo src={KuterStudio} alt="Kuter Studio" />
          </TwoColumn>
        </Row>
        <Row>
          <TwoColumn className="clickable" onClick={goToPostProduction}>
            <XImg src={xPost} alt="X Post" />
            <GridLogo src={KuterPost} alt="Kuter Post" />
          </TwoColumn>
          <TwoColumn className="clickable" onClick={goToAiServices}>
            <XImg src={xAi} alt="X AI" />
            <GridLogo src={KuterAi} alt="Kuter Ai" />
          </TwoColumn>
          <TwoColumn>
            <XImg src={xHuman} alt="X Human" />
            <GridLogo src={KuterHuman} alt="Kuter Human" />
          </TwoColumn>
        </Row>
      </Container>
    </>
  );
};

export default LogoContainer;
